import PropTypes from 'prop-types';
import { logoPropTypes } from './components/Logo/LogoPropTypes';
// import { searchBarPropTypes } from './components/SearchBar/SearchBarPropTypes';
import { headerItemsCollectionPropTypes } from './components/HeaderItemsCollection/HeaderItemsCollectionPropTypes';
import { navPropTypes } from './components/Nav/NavPropTypes';
import { searchResultsPropTypes } from '@Theme/natucare/modules/Header/components/MainBar/components/SearchResults/SearchResultsPropTypes';
export const mainBarPropTypes = {
  nav: PropTypes.shape(navPropTypes),
  logo: PropTypes.shape(logoPropTypes),
  // searchBar: PropTypes.shape(searchBarPropTypes),
  headerItemsCollection: headerItemsCollectionPropTypes.items,
  popularSearches: PropTypes.arrayOf(PropTypes.shape({
    label: PropTypes.string.isRequired,
    href: PropTypes.string
  })),
  onChange: PropTypes.func,
  isMobileOpen: PropTypes.bool,
  handleOpenMobile: PropTypes.func,
  setIsSearching: PropTypes.func,
  isSearching: PropTypes.bool,
  searchResults: searchResultsPropTypes.searchResults,
  searchTerm: PropTypes.string,
  sendSearchData: PropTypes.func,
  headerRef: PropTypes.any,
  hasScrolled: PropTypes.bool
};